import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import {
  defaultImg,
  fileupload,
  leftArrow,
  tableEye,
} from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import { FaEye } from "react-icons/fa";

const AddVehicleTransport = () => {
  const navigation = useNavigate();
  const [image, setImage] = useState(null);
  //    const [isEdit,setIsEdit]=useState(false);
  // const [loader, setLoader] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const location = useLocation();
  console.log("location", location);
  const STORAGE_KEYS = {
    transport: "tm_transport_context",
    vehicle: "tm_vehicle_context",
    type: "tm_context_type",
  };
  const readStorage = (key) => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  };
  const writeStorage = (key, value) => {
    try {
      if (value === undefined || value === null) return;
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      // ignore storage errors
    }
  };
  const [context, setContext] = useState(() => {
    const state = location.state || {};
    return {
      datas: state.datas ?? readStorage(STORAGE_KEYS.transport),
      type: state.type ?? readStorage(STORAGE_KEYS.type),
      data: state.data ?? readStorage(STORAGE_KEYS.vehicle),
    };
  });
  const { type, datas, data } = context;
  const [adminList, setAdminList] = useState([]);
  // const [adminData,setAdminData] =useState([]);
  const [viewerFile, setViewerFile] = useState("");
  const [viewerOpen, setViewerOpen] = useState(false);

  const fileRefs = useRef({});

  const openFileViewer = (fileUrl) => {
    setViewerFile(fileUrl);
    setViewerOpen(true);
  };

  console.log("datasdatas", datas);

  const [form, setForm] = useState({
    vehicleno: "",
    vehicletype: "",
    vehicle_model: "",
    maxvolume: "",
    vehicleRccopies: "",
    fitnesscertificate: "",
    insurancecertificate: "",
    pollutioncertificate: "",
    transportlicense: "",
  });

  useEffect(() => {
    const state = location.state || {};
    if (state?.datas || state?.type || state?.data) {
      setContext((prev) => ({
        datas: state?.datas ?? prev.datas,
        type: state?.type ?? prev.type,
        data: state?.data ?? prev.data,
      }));
      if (state?.datas) writeStorage(STORAGE_KEYS.transport, state.datas);
      if (state?.type) writeStorage(STORAGE_KEYS.type, state.type);
      if (state?.data) writeStorage(STORAGE_KEYS.vehicle, state.data);
    }
  }, [location.state]);

  useEffect(() => {
    setForm({
      vehicleno: data?.vehicle_no,
      vehicletype: data?.vehicle_type,
      // status: "",
      vehicle_model: data?.vehicle_model,
      vehicleRccopies: data?.rc_copy_url,
      fitnesscertificate: data?.fitness_url,
      insurancecertificate: data?.insurance_url,
      pollutioncertificate: data?.pollution_url,
      transportlicense: data?.transport_license_url,
    });
    if (data?.image_url) {
      setImage({
        file: null,
        preview: data?.image_url,
      });
    }
  }, [data]);

  const tabs = [
    { name: "Vehicles Details", path: "/addvehicle-transport" },
    { name: "Vehicles Trip History", path: "/vehicle-triphistory" },
  ];
  const removeImage = () => {
    setImage(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage({
        file,
        preview: URL.createObjectURL(file),
      });
    }
  };

  const [formData, setFormData] = useState({
    vehicle_no: "",
    vehicle_type: "",
    vehicle_model: "",
    max_volume: "",
    rc_copy: "",
    fitness_certificate: "",
    insurance_certificate: "",
    pollution_certificate: "",
    transport_license: "",
  });

  // ✅ Handle File Change (Same as your TransportView)
  const handleFileChange = (e, id, name) => {
    const file = e.target.files[0];

    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [id]: file.name,
      }));

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    }
  };

  const vehicleFields = [
    { id: 1, name: "vehicle_no", label: "Vehicle No", fileupload: false },
    {
      id: 2,
      name: "vehicle_type",
      label: "Vehicle Type",
      fileupload: false,
      dropdown: true,
      value: form?.vehicletype,
    },
    { id: 3, name: "vehicle_model", label: "vehicle Model", fileupload: false },
    {
      id: 4,
      name: "rc_copy",
      label: "Vehicle RC Copies",
      fileupload: true,
      value: "rc_copy_url",
    },
    {
      id: 5,
      name: "fitness_certificate",
      label: "Fitness Certificate",
      fileupload: true,
      value: "fitness_url",
    },
    {
      id: 6,
      name: "insurance_certificate",
      label: "Insurance Certificate",
      fileupload: true,
      value: "insurance_url",
    },
    {
      id: 7,
      name: "pollution_certificate",
      label: "Pollution Certificate",
      fileupload: true,
      value: "pollution_url",
    },
    {
      id: 8,
      name: "transport_license",
      label: "Transport License",
      fileupload: true,
      value: "transport_licence_url",
    },
  ];

  const getExistingFileUrl = (key) => {
    if (!data) return "";
    return data?.[key] ?? "";
  };

  const validateForm = () => {
    const vehicleNo = String(formData?.vehicle_no || "").trim();
    const vehicleModel = String(formData?.vehicle_model || "").trim();

    if (!vehicleNo) {
      toast.error("Please enter the vehicle number");
      return false;
    }
    if (!vehicleModel) {
      toast.error("Please enter the vehicle model");
      return false;
    }
    if (!formData?.vehicle_type) {
      toast.error("Please select the vehicle type");
      return false;
    }

    const requiredFiles = [
      { key: "rc_copy", label: "Vehicle RC Copies", dataKey: "rc_copy_url" },
      {
        key: "fitness_certificate",
        label: "Fitness Certificate",
        dataKey: "fitness_url",
      },
      {
        key: "insurance_certificate",
        label: "Insurance Certificate",
        dataKey: "insurance_url",
      },
      {
        key: "pollution_certificate",
        label: "Pollution Certificate",
        dataKey: "pollution_url",
      },
      {
        key: "transport_license",
        label: "Transport License",
        dataKey: "transport_licence_url",
      },
    ];

    for (const fileField of requiredFiles) {
      const hasNewFile = formData?.[fileField.key] instanceof File;
      const hasExisting = Boolean(getExistingFileUrl(fileField.dataKey));
      if (!hasNewFile && !hasExisting) {
        toast.error(`Please upload ${fileField.label}`);
        return false;
      }
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      setIsLoading(true);

      const payload = new FormData();
      const transportId = localStorage.getItem("transport_id");
      //  payload.append("transport_id", transportId);
      // ✅ Append normal fields
      payload.append("vehicle_no", formData?.vehicle_no);
      payload.append("vehicle_type", formData?.vehicle_type);
      payload.append("vehicle_model", formData?.vehicle_model);
      // payload.append("status", formData?.status);

      // ✅ Append file fields (only if File object)
      if (formData?.rc_copy instanceof File) {
        payload.append("rc_copy", formData.rc_copy);
      }

      if (formData?.fitness_certificate instanceof File) {
        payload.append("fitness", formData.fitness_certificate);
      }

      if (formData?.insurance_certificate instanceof File) {
        payload.append("insurance", formData.insurance_certificate);
      }

      if (formData?.pollution_certificate instanceof File) {
        payload.append("pollution", formData.pollution_certificate);
      }

      if (formData?.transport_license instanceof File) {
        payload.append("transport_licence", formData.transport_license);
      }

      // ✅ Append vehicle image if selected
      if (image?.file) {
        payload.append("image", image.file);
      }

      // const transportId = localStorage.getItem("transport_id");

      // payload.append("transport", Number(transportId));

      //  payload.append('transport', datas?.transport_id || data?.id )
      payload.append(
        "transport",
        datas?.transport || data?.transport || datas?.id || data?.id,
      );

      console.log(
        "payload",
        payload,
        datas?.transport_id,
        data?.transport,
        datas,
        data,
      );

      // ========================
      // ✅ ADD
      // ========================
      if (type === "add") {
        setIsLoading(true);

        const res = await post(URLS.VEHICLE_TRANSPORT_ADD, payload);

        if (res?.status === "success") {
          toast.success(res?.message || "Vehicle Added Successfully");
          setIsLoading(false);
          navigation(-1);
        }
      } else {
        const res = await put(
          `${URLS.VEHICLE_TRANSPORT_EDIT}${data?.id}/`,
          payload,
        );

        if (res?.status === "success") {
          toast.success(res?.message || "Vehicle Updated Successfully");
          setIsEditing(false);
          setIsLoading(false);
          navigation(-1);
        }
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      // setLoader(false);
      setIsLoading(false);
    }
  };

  const handleTabClick = (tab) => {
    if (datas) writeStorage(STORAGE_KEYS.transport, datas);
    if (type) writeStorage(STORAGE_KEYS.type, type);
    if (data) writeStorage(STORAGE_KEYS.vehicle, data);
    navigation(tab.path, { state: { datas, type, data } });
  };

  const getList = async () => {
    try {
      const response = await get(`${URLS.VEHICLE_LIST_TYPE}`);
      console.log("res", response);
      setAdminList(response?.data);
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    getList();
  }, []);
  console.log("adminList", adminList);

  useEffect(() => {
    if (data) {
      const selectedVehicleType =
        data?.vehicle_type_id ??
        (typeof data?.vehicle_type === "number"
          ? data?.vehicle_type
          : adminList?.find(
              (item) =>
                String(item?.type || "").toLowerCase() ===
                String(data?.vehicle_type || "").toLowerCase(),
            )?.id) ??
        "";

      setFormData({
        vehicle_no: data?.vehicle_no || "",
        vehicle_type: selectedVehicleType,
        //   status: data?.status || "",
        vehicle_model: data?.vehicle_model || "",
        rc_copy: data?.rc_copy || "",
        fitness_certificate: data?.fitness_certificate || "",
        insurance_certificate: data?.insurance_certificate || "",
        pollution_certificate: data?.pollution_certificate || "",
        transport_license: data?.transport_license || "",
      });
    }

    if (type === "view") {
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  }, [data, type, adminList]);

  useEffect(() => {
    if (!datas?.id) {
      toast.error(
        "Transport details missing. Please open from Transport Details.",
      );
    }
  }, [datas]);

  return (
    <>
      <Header />

      <div style={{ marginTop: "6rem", padding: "15px" }}>
        <div className="section">
          <h3 onClick={() => navigation(-1)} className="section-titlez">
            <img
              src={leftArrow}
              style={{ marginRight: 10 }}
              className="back-icon-arrow"
              alt=""
            />
            Vehicles
          </h3>
          {/* Tabs */}
          {type === "view" && (
            <div className="tabs mb-4 ms-3">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => handleTabClick(tab)}
                  className={`tab-btn ${
                    location.pathname === tab.path ? "active" : ""
                  }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>
          )}

          <div className="form-groupz">
            <label>Vehicle Images</label>
          </div>

          <div className="image-list">
            {image ? (
              <div className="image-card">
                <img disabled={!isEditing} src={image.preview} alt="vehicle" />
                {isEditing && (
                  <button className="remove-btn" onClick={removeImage}>
                    ×
                  </button>
                )}
              </div>
            ) : (
              <label className="">
                <img src={defaultImg} className="imageSize" alt="vehicle" />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  hidden
                  disabled={!isEditing}
                />
              </label>
            )}
          </div>

          {/* FORM GRID */}
          <div className="form-grid">
            {vehicleFields.map((item) => {
              const uniqueId = `vehicle-${item.id}`;

              // const currentFileValue =item?.value?data?.[item?.value]??'':
              //   uploadedFiles[uniqueId] ||
              //   (formData[item.name] instanceof File
              //     ? formData[item.name].name
              //     : formData[item.name] || "");

              // const currentFileValue =
              //   uploadedFiles[uniqueId] ||
              //   (formData[item.name] instanceof File
              //     ? formData[item.name].name
              //     : item?.value
              //       ? (data?.[item?.value] ?? "")
              //       : formData[item.name] || "");
              const currentFileValue =
                uploadedFiles[uniqueId] || formData[item.name]
                  ? `${item.label} `
                  : "";
              const viewerUrl =
                (typeof formData[item.name] === "string" &&
                  formData[item.name]) ||
                (item?.value ? (data?.[item?.value] ?? "") : "");

              console.log(
                "testing value",
                currentFileValue,
                formData[item.name],
                formData,
              );
              return (
                <div className="form-groupz" key={uniqueId}>
                  <label>{item.label}</label>

                  {item.fileupload ? (
                    <div
                      className="upload-boxz"
                      style={{ cursor: isEditing ? "pointer" : "default" }}
                    >
                      <input
                        type="text"
                        placeholder={` ${item.label}`}
                        value={currentFileValue}
                        readOnly
                      />

                      <input
                        type="file"
                        id={`file-${uniqueId}`}
                        onChange={(e) =>
                          handleFileChange(e, uniqueId, item.name)
                        }
                        style={{ display: "none" }}
                        ref={(el) => {
                          fileRefs.current[uniqueId] = el;
                        }}
                        disabled={!isEditing}
                      />

                      {isEditing ? (
                        /* Upload icon in edit mode */

                        <img
                          src={fileupload}
                          alt="upload"
                          className="uploadIcon"
                          onClick={(e) => {
                            e.stopPropagation();
                            fileRefs.current[uniqueId]?.click();
                          }}
                        />
                      ) : (
                        /* Eye icon in view mode */

                        viewerUrl && (
                          <FaEye
                            className="viewIcon"
                            style={{
                              cursor: "pointer",
                              fontSize: "18px",
                              marginRight: 10,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openFileViewer(viewerUrl);
                            }}
                          />
                        )
                      )}
                    </div>
                  ) : item.dropdown ? (
                    <select
                      className="fileinput"
                      value={formData[item.name] || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [item.name]: e.target.value,
                        })
                      }
                      disabled={!isEditing}
                    >
                      <option value="">Select {item.label}</option>
                      {adminList?.map((listItem) => (
                        <option key={listItem?.id} value={listItem?.id}>
                          {listItem?.type}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      placeholder={`Enter ${item.label}`}
                      className="fileinput"
                      value={formData[item.name] || ""}
                      // value={currentFileValue || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [item.name]: e.target.value,
                        })
                      }
                      readOnly={!isEditing}
                    />
                  )}
                </div>
              );
            })}
          </div>

          {/* ACTION BUTTONS */}
          {type === "add" && (
            <div className="actions">
              <button
                className="save-btn"
                onClick={() => handleSave()}
                //   onClick={()=>navigation(-1)}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Add"
                )}
              </button>
            </div>
          )}
          {type === "view" && (
            <div className="actions">
              {!isEditing && (
                <button
                  onClick={() => setIsEditing(!isEditing)}
                  // onClick={()=>handleSave()}
                  className={"edit-btn"}
                >
                  {"Edit"}
                </button>
              )}
              {isEditing && (
                <button
                  //   onClick={() => setIsEditing(!isEditing)}
                  onClick={() => handleSave()}
                  className={"save-btn"}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              )}
            </div>
          )}
        </div>
        <Modal
          show={viewerOpen}
          onHide={() => setViewerOpen(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Document Viewer</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ height: "80vh" }}>
            {viewerFile?.toLowerCase().endsWith(".pdf") ? (
              <iframe
                src={`${viewerFile}#toolbar=0`}
                title="PDF Viewer"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            ) : (
              <img
                src={viewerFile}
                alt="Document"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default AddVehicleTransport;
